<script>
import { Line } from 'vue-chartjs'

export default {
    extends: Line,

    props: ['timeNamelookup', 'timeTcpConnection', 'timeRedirect', 'timeContentGeneration', 'timeContentTransfer', 'timeTotal', 'labels', 'translations'],

    mounted() {
        this.renderChart(
            {
                labels: this.labels,
                datasets: [
                    {
                        label: this.translations.name_lookup,
                        fill: false,
                        borderColor: '#0e9f6e',
                        borderDash: [2, 2],
                        borderWidth: 1,
                        pointBackgroundColor: '#fff',
                        pointBorderColor: '#0e9f6e',
                        data: this.timeNamelookup,
                    },
                    {
                        label: this.translations.tcp_connection,
                        fill: false,
                        borderColor: '#c27803',
                        borderDash: [2, 2],
                        borderWidth: 1,
                        pointBackgroundColor: '#fff',
                        pointBorderColor: '#c27803',
                        data: this.timeTcpConnection,
                    },
                    {
                        label: this.translations.redirect,
                        fill: false,
                        borderColor: '#e74694',
                        borderDash: [2, 2],
                        borderWidth: 1,
                        pointBackgroundColor: '#fff',
                        pointBorderColor: '#e74694',
                        data: this.timeRedirect,
                    },
                    {
                        label: this.translations.content_generation,
                        fill: false,
                        borderColor: '#ff5a1f',
                        borderDash: [2, 2],
                        borderWidth: 1,
                        pointBackgroundColor: '#fff',
                        pointBorderColor: '#ff5a1f',
                        data: this.timeContentGeneration,
                    },
                    {
                        label: this.translations.content_transfer,
                        fill: false,
                        borderColor: '#961fff',
                        borderDash: [2, 2],
                        borderWidth: 1,
                        pointBackgroundColor: '#fff',
                        pointBorderColor: '#961fff',
                        data: this.timeContentTransfer,
                    },
                    {
                        label: this.translations.total,
                        borderColor: '#4E92D1',
                        backgroundColor: 'transparent',
                        pointBackgroundColor: '#fff',
                        pointBorderColor: '#4E92D1',
                        data: this.timeTotal,
                    },
                ],
            },
            {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    //display: false,
                    position: 'bottom',
                    labels: {
                        padding: 20,
                        boxWidth: 20,
                    },
                },
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: true,
                                min: 0,
                            },
                        },
                    ],
                },
            },
        )
    },
}
</script>
